export const MARGIN_TOP = 0;
export const MARGIN_BOTTOM = '1rem';
